import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthFooter from "../../../components/AuthFooter/AuthFooter";
import UserInfoForm from "../../../components/CreateAccount/UserInfoForm";
import Stepper from "../../../components/Stepper/Stepper";
import { RegisterFormContext } from "./RegisterFormContext";

/**
 * A component for the user info step in the registeration process.
 *
 * It is simply a wrapper around the UserInfoForm component that provides it with the necessary values from the context
 *
 * @returns {JSX.Element}
 */

const UserInforStep = () => {
  const navigate = useNavigate();
  const { email, phone, userInfoSubmit, activeStep, steps, userInfo } =
    useContext(RegisterFormContext);

  const initialValues = {
    first_name: userInfo.firstName,
    last_name: userInfo.lastName,
    gender: userInfo.gender,
    nationality: userInfo.nationality,
    day: userInfo.dob.split("-")?.[2],
    month: userInfo.dob.split("-")?.[1],
    year: userInfo.dob.split("-")?.[0],
    email,
    phone,
  };

  return (
    <>
      <div className="sm:w-screen w-full position relative">
        <div className="-z-10 position absolute left-0 top-0">
          <img
            src="./assets/signin/left_vector.png"
            alt="left_vector"
            className="w-20 h-20 md:w-48 md:h-48"
          />
        </div>
        <div className="-z-10 position absolute right-0 bottom-0">
          <img
            src="./assets/signin/right_vector.png"
            alt="right_vector"
            className="w-16 md:w-48 h-12 md:h-36"
          />
        </div>
        <div className="sm:w-screen w-full min-h-screen overflow-auto">
          <div className="flex flex-col justify-center items-center">
            <button
              className="mt-4 mb-2 cursor-pointer"
              onClick={() => navigate("/")}
            >
              <img
                src="./assets/header/LogoSVG.svg"
                alt="Moshrouk Trips"
                className="w-16 h-13"
              />
            </button>
            <div className="bg-text_white  mt-2 block w-72 md:w-[480px] p-3 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 md:max-w-[500px]">
              <div className="w-auto p-1">
                <div>
                  <Stepper
                    steps={steps}
                    subTab={activeStep}
                    className={
                      "flex items-center w-full text-sm font-medium text-center py-2 border-b text-gray-500 sm:text-base justify-between"
                    }
                  />
                </div>
                <UserInfoForm
                  initialValues={initialValues}
                  userInfoSubmit={userInfoSubmit}
                />
              </div>
            </div>
            <div className="">
              <AuthFooter />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserInforStep;
